import { Icon } from '@aqarmap/aqarmap-ui';
import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import startAnimationData from '~/animations/start.json';

const AutoGenerateButton = ({
  isSuccess,
  isLoading,
  handleGenerateValueByAI,
  language,
  className,
}: {
  isSuccess: boolean;
  isLoading: boolean;
  handleGenerateValueByAI: () => void;
  language: 'arabic' | 'english';
  className?: string;
}) => {
  const { t } = useTranslation('app', {
    lng: language === 'arabic' ? 'ar' : 'en',
  });
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  useEffect(() => {
    if (isLoading) {
      lottieRef.current?.play();
    } else {
      lottieRef.current?.stop();
    }
  }, [isLoading]);

  return (
    <button
      className={`${className} ${
        isSuccess ? 'text-gray' : 'text-blue'
      } bg-gray_light_1  rounded-[8px] px-2x py-0.5x text-link h-[32px] flex items-center gap-1`}
      onClick={() => handleGenerateValueByAI()}
      disabled={isSuccess || isLoading}
    >
      {isSuccess ? (
        <Icon name="check" className="text-gray" />
      ) : (
        <Lottie
          lottieRef={lottieRef}
          animationData={startAnimationData}
          loop={true}
          autoplay={false}
          className="w-[24px] h-[24px]"
        />
      )}
      <span>{isSuccess ? t('autoGenerated') : t('autoGenerate')}</span>
    </button>
  );
};

export default AutoGenerateButton;
